module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_toys_e0eb603e12bf6f8a8ff9c9115b164745.png";